import _ from '@fortawesome/fontawesome-free/js/all';
import { Notifier } from '@airbrake/browser';
import {
	contents
} from './stores';

import { authSvc, mappingSvc } from './services';
import { baseApiUrl } from './constants';
import App from './App.svelte';

window.airbrake = new Notifier({
	projectId: 357055,
	projectKey: '667bcfa01c97f8d9d2b143b5f3593908',
	environment: location.hostname.indexOf('platzreife.be-golf.com') !== -1 ? 'production' : 'development'
});

let app;

fetch(baseApiUrl + 'wp/v2/contents?per_page=30')
	.then(c => c.json())
	.then(c => {
		const pageContents = mappingSvc.mapContents(c);
		contents.set(pageContents);
		app = new App({
			target: document.getElementById('app'),
			props: {
				pageContents
			}
		});
	});

export default app;

window.authSvc = authSvc;